var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      !_vm.hasModule
        ? _c("app-missing-module-modal", {
            attrs: { "module-id": _vm.requiredModuleId },
            on: {
              close: function ($event) {
                return _vm.close()
              },
            },
          })
        : _vm._e(),
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("bank-balance-title")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-list" } },
        _vm._l(_vm.balances, function (item) {
          return _c(
            "w-list-item",
            { key: item.TypeID },
            [
              _vm._v(" " + _vm._s(item.Name) + " "),
              _c("w-spacer"),
              _vm._v(" " + _vm._s(_vm._f("printHumanFloat")(item.Total)) + " "),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.Ok")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }